import React, { createContext } from 'react';

const CONTEXT_USER_FOR_CLASS_COMPONENTS = React.createContext()

export const CONTEXT_USER_FOR_CLASS_COMPONENTSProvider = CONTEXT_USER_FOR_CLASS_COMPONENTS.Provider
export const CONTEXT_USER_FOR_CLASS_COMPONENTSConsumer = CONTEXT_USER_FOR_CLASS_COMPONENTS.Consumer

export default CONTEXT_USER_FOR_CLASS_COMPONENTS
